import React from "react";
import "../../../assets/css/user/HeroSection.css";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  // ✅ Right panel — aapki categories
  const services = [
    {
      id: 1,
      title: "AC Service & Repairing",
      icon: "❄️",
      color: "#8B5CF6",
      tag: "Book & Save",
    },
    {
      id: 2,
      title: "Solar Panel Companies",
      icon: "☀️",
      color: "#22C55E",
      tag: "Book & Save",
    },
    {
      id: 3,
      title: "Camera Installation & Repairing",
      icon: "📷",
      color: "#EC4899",
      tag: "Book & Save",
    },
    {
      id: 4,
      title: "Car Wash",
      icon: "🚗",
      color: "#00A8E1",
      tag: "Book & Save",
    },
  ];

  return (
    <div className="hs-hero-section">
      <div className="hs-hero-container">
        {/* ── Left Content ── */}
       
        <div className="hs-hero-content">
          <div className="hs-badge">
            <span className="hs-badge-icon">⚡</span>
            Instant Deals are Live Now!
          </div>

          <h1 className="hs-hero-title">
            Grab <span className="hs-hero-title-highlight">Instant Deals</span>{" "}
            Before They <span className="hs-hero-title-highlight">Expire</span>!
          </h1>

          <p className="hs-hero-description">
            Pakistan's first marketplace for time-limited deals. Sellers offer
            discounted services, you grab them instantly. Everyone wins!
          </p>

          <div className="hs-hero-buttons">
            <button
              className="hs-btn-primary"
              onClick={() => navigate("/deals")}
            >
              ⚡ Explore Deals
            </button>
            <button
              className="hs-btn-secondary"
              onClick={() => navigate("/seller-signup")}
            >
              Become a Seller
            </button>
          </div>
        </div>

        {/* ── Right Panel — Live Categories ── */}
        <div className="hs-live-panel">
          <div className="hs-live-panel-header">
            <span className="hs-live-panel-title">
              <span className="hs-live-panel-icon">⚡</span> Live Categories
            </span>
            {/* <span className="hs-live-badge"> */}
              {/* <span className="hs-live-dot" /> LIVE
            </span> */}
          </div>

          <div className="hs-live-list">
            {services.map((service) => (
              <div
                key={service.id}
                className="hs-live-item"
                onClick={() => navigate("/deals")}
              >
                <div
                  className="hs-live-item-icon"
                  style={{ backgroundColor: service.color }}
                >
                  {service.icon}
                </div>
                <div className="hs-live-item-info">
                  <h4 className="hs-live-item-title">{service.title}</h4>
                  <span className="hs-live-item-subtitle">
                    Verified Providers
                  </span>
                </div>
                <div className="hs-live-item-meta">
                  <span className="hs-live-item-tag">{service.tag}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
